import styled, {css} from 'styled-components';
import {rem} from 'polished';
import {List, Button, Input} from 'global/styles/styles.js';

const BetSlipTypesTabsBackground = ({theme:{$betSlipTypesTabsBackground}}) => `${$betSlipTypesTabsBackground}`;
const BetSlipTypesTabsTabColor = ({theme:{$betSlipTypesTabsTabColor}}) => `${$betSlipTypesTabsTabColor}`;
const BetSlipTypesTabsTabActiveColor = ({theme:{$betSlipTypesTabsTabActiveColor}}) => `${$betSlipTypesTabsTabActiveColor}`;
const BetSlipTypesTabsAnchor = ({theme:{$betSlipTypesTabsAnchor}}) => `${$betSlipTypesTabsAnchor}`;
const BetSlipTypesTabsClearSlip = ({theme:{$betSlipTypesTabsClearSlip}}) => `${$betSlipTypesTabsClearSlip}`;
const BetSlipTypesTabsBorderColor = ({theme:{$betSlipTypesTabsBorderColor}}) => `${$betSlipTypesTabsBorderColor}`;

const baseFont = `12px`;

const S = {};

S.BetSlipTypesTabs = styled.div`
    font-family: "Roboto Condensed", sans-serif;
    display: flex;
    height: ${rem('40px', baseFont)};
    background-color: ${BetSlipTypesTabsBackground};
    padding: 0 ${rem('8px', baseFont)};
    line-height: 1;
    border-bottom: 1px solid ${BetSlipTypesTabsBorderColor};
    
    & > ${S.BetSlipTypeTab}{
       &:first-of-type{
          margin-right: ${rem('30px', baseFont)};
       }
    }
`;

S.BetSlipTypeTab = styled(Button)`
    padding: 0;
    font-size: ${rem('12px', baseFont)};
    background-color: transparent;
    ${({isActive}) => {
        return (isActive == true) ?
        css`
            color: ${BetSlipTypesTabsTabActiveColor};
            font-weight: bold;
        `:
        css`
            color: ${BetSlipTypesTabsTabColor}
        `
    }}};
    
`;

S.ClearBetSlip = styled(Button)`
    padding: 0;
    background-color: transparent;
    line-height: 1;
    align-self: center;
    color: ${BetSlipTypesTabsClearSlip};
    
    &:before{
        font-size: ${rem('16px', baseFont)};
    }
`;

S.LockBetSlip = styled(Button)`
    margin-left: auto;
    padding: 0;
    margin-right: ${rem('15px', baseFont)};
    background-color: transparent;
    line-height: 1;
    align-self: center;
    color: ${({isSticked}) => {
        return (isSticked == true) ? '#A1A1A1' : css`${BetSlipTypesTabsAnchor}`;
    }}};
    
    &:before{
        font-size: ${rem('14px', baseFont)};
    }
`;

export default S;